import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {v4 as uuidv4} from "uuid";
import {FeedbackItem} from "../types/feedback";

const FEEDBACKS_COLLECTION_ID = "678e9681003db0834e1e"
const databases = new Databases(client);

export const feedbackService = {
  async create(data: FeedbackItem): Promise<FeedbackItem> {
    try {
      const feedback = await databases.createDocument(
        database_id,
        FEEDBACKS_COLLECTION_ID,
        uuidv4(),
        data
      ) as unknown as FeedbackItem;

      return feedback;
    } catch (error) {
      // console.error('Помилка створення новини:', error);
      throw error;
    }
  },

  async list(queries: string[] = [], limit: number = 100): Promise<FeedbackItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        FEEDBACKS_COLLECTION_ID,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      const list = response.documents.map(doc => doc as unknown as FeedbackItem);
      return list;
    } catch (error) {
      // console.error('Error listing news:', error);
      throw error;
    }
  },

  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        FEEDBACKS_COLLECTION_ID,
        id
      );
    } catch (error) {
      // console.error('Error deleting news:', error);
      throw error;
    }
  },
}